<template>
  <div class="ui large modal" ref="modal">
    <div class="header">Boleto</div>
    <div class="scrolling content">
      <div class="ui padded grid">
        <div class="row">
          <div class="four wide column">
            <div>
              Contract: <b>{{ invoice.contract_id }}</b>
            </div>
            <div>
              Titular: <b>{{ contract.owner_name }}</b>
            </div>
            <div>
              Parcela: <b>{{ invoice.number | sequence }}</b>
            </div>
            <div>
              Valor: <b>{{ invoice.amount | money }}</b>
            </div>
            <div>
              Vencimento: <b>{{ invoice.due_date | date }}</b>
            </div>
            <div>
              Competência: <b>{{ invoice.competence }}</b>
            </div>
          </div>
          <div v-if="requested" class="twelve wide column">
            <div :class="['ui placeholder', { loading: loading }, 'segment']">
              <div class="ui icon header">
                <i class="check icon"></i>
                Boleto Solicitado
              </div>
            </div>
          </div>
          <div v-else-if="hasTicket" class="twelve wide column">
            <div :class="['ui', { loading: loading }, 'segment']">
              <form class="ui form">
                <div class="field">
                  <label>Código</label>
                  <div class="ui action input">
                    <input
                      type="text"
                      disabled
                      v-model="invoice.ticket_barcode"
                      style="opacity: 1"
                    />
                    <button
                      type="button"
                      @click.prevent="copy()"
                      class="ui right labeled icon button"
                    >
                      <i class="copy icon"></i>
                      {{ copyButtonText }}
                    </button>
                  </div>
                </div>
                <div class="field">
                  <label>URL</label>
                  <a target="_blank" :href="invoice.ticket_url">
                    {{ invoice.ticket_url }}
                  </a>
                </div>
              </form>
            </div>
          </div>
          <div v-else class="twelve wide column">
            <div :class="['ui placeholder', { loading: loading }, 'segment']">
              <div class="ui icon header">
                <i class="barcode icon"></i>
                Nenhum boleto encontrado.
              </div>
              <button
                type="button"
                @click.prevent="generateTicket"
                class="ui primary button"
              >
                Gerar Boleto Bancário
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Api from '@/resources/Api';
export default {
  data() {
    return {
      loading: false,
      copyButtonText: 'Copiar',
      contract: {
        owner_name: null
      },
      invoice: {
        number: null,
        competence: null,
        amount: null,
        contract_id: null
      }
    };
  },

  computed: {
    hasTicket() {
      return (
        this.invoice.ticket_barcode != null && this.invoice.ticket_url != null
      );
    },

    requested() {
      return (
        this.invoice.transaction_id != null &&
        this.invoice.ticket_barcode == null &&
        this.invoice.ticket_url == null
      );
    }
  },

  methods: {
    copy() {
      navigator.clipboard.writeText(this.invoice.ticket_barcode);
      this.copyButtonText = 'Copiado!';
      setTimeout(() => {
        this.copyButtonText = 'Copiar';
      }, 1000);
    },

    open(invoice, contract) {
      this.invoice = invoice;
      this.contract = contract;
      window.$(this.$refs.modal).modal('show');
    },

    async generateTicket() {
      this.loading = true;

      Api.invoices
        .ticket(this.invoice.id)
        .then(async response => {
          this.$toast.show('Boleto gerado com sucesso', 'success');
          this.invoice = response.data.invoice;

          setTimeout(() => {
            this.hide();
            this.$parent.refresh();
          }, 1000);
        })
        .catch(error => {
          if (error.response) {
            this.$toast.show(error.response.data.error, 'error');
          } else {
            throw error;
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },

    hide() {
      window.$(this.$refs.modal).modal('hide');
    }
  }
};
</script>
